function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "right-nav",
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("g", {
  id: "arrow"
}, /*#__PURE__*/React.createElement("path", {
  id: "Vector",
  d: "M6.34073 2.29115e-05C7.96571 -0.00292327 9.52634 0.507034 10.6827 1.41881L39.4662 24.118C40.0312 24.5637 40.4799 25.0945 40.7861 25.6797C41.0923 26.2648 41.25 26.8928 41.25 27.527C41.25 28.1612 41.0923 28.7891 40.7861 29.3743C40.4799 29.9595 40.0312 30.4903 39.4662 30.936L10.799 53.5436C9.60469 54.4809 7.99576 55.0042 6.32133 55C4.6469 54.9958 3.04211 54.4644 1.85524 53.5211C0.667232 52.5702 2.36704e-05 51.2818 3.20706e-07 49.9385C-2.3029e-05 48.5953 0.667145 47.3068 1.85512 46.3559L23.1573 29.3434C23.8209 28.8122 24.1937 28.0923 24.1937 27.3419C24.1937 26.5914 23.8209 25.8717 23.1573 25.3404L1.97067 8.42029C1.10549 7.73072 0.516079 6.85156 0.277153 5.89421C0.0382263 4.93687 0.160543 3.94443 0.628564 3.04265C1.09659 2.14087 1.88926 1.37033 2.90616 0.828671C3.92306 0.287013 5.1184 -0.00139783 6.34073 6.93505e-06V2.29115e-05Z",
  fill: "#00BFA6"
})));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("rect", {
  width: 41.25,
  height: 55,
  fill: "white"
})));

function SvgRightNavigationIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 55,
    viewBox: "0 0 42 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightNavigationIcon);
export default __webpack_public_path__ + "static/media/right-navigation-icon.89eeb6fb.svg";
export { ForwardRef as ReactComponent };